module.exports = __webpack_public_path__ + "static/media/leftChevron.208255a0.svg";